export const environment = {
  production: false,
  apiUrl: '',
  apiClientKey: '',
  tradeEventApiUrl: '',
  juliaApiUrl: '',
  juliaProject: 'enegoce',
  xHeaderName: '',
  csrfCookieName: '',
  juliaLogo: 'assets/logo/logo_ibs.png',
  // Julia chat: give up if no frame arrives for this long. Must stay well above
  // the backend's STREAM_HEARTBEAT_SECONDS (10s).
  juliaStreamInactivityMs: 60000,
  logoLogin: 'assets/images/logoLoginTnegoce.png',
  logoSideBarOpenCorporate: 'assets/images/logoSideBarOpenCorporateTnegoce.png',
  logoSideBarOpenBank: 'assets/images/logoSideBarOpenBankTnegoce.png',
  logoSideBarOpenAdmin: 'assets/images/logoSideBarOpenAdminTnegoce.png',
  logoSideBarCollapsedCorporate: 'assets/images/logoSideBarCollapsedCorporate.png',
  logoSideBarCollapsedBank: 'assets/images/logoSideBarCollapsedBank.png',
  logoSideBarCollapsedAdmin: 'assets/images/logoSideBarCollapsedAdmin.png'
};
